import { CardType, Maybe, Operation } from '../../../__generated__/globalTypes'

import {
  PanelFragment,
  panelFragmentString,
} from '../../fragments/__generated__/PanelFragment'

import { textFragmentFragmentString } from '../../fragments/__generated__/TextFragmentFragment'

import { colorFragmentString } from '../../fragments/__generated__/ColorFragment'

import { elementFragmentString } from '../../fragments/__generated__/ElementFragment'

import { elementPictureFragmentString } from '../../fragments/__generated__/ElementPictureFragment'

import { imageFragmentString } from '../../fragments/__generated__/ImageFragment'

import { elementTextFragmentString } from '../../fragments/__generated__/ElementTextFragment'

import { paragraphFragmentString } from '../../fragments/__generated__/ParagraphFragment'

import getOrCreateEditableCardForRecipientRawString from '../GetOrCreateEditableCardForRecipient.graphql'

const getOrCreateEditableCardForRecipientString = [
  getOrCreateEditableCardForRecipientRawString,
  panelFragmentString,
  textFragmentFragmentString,
  colorFragmentString,
  elementFragmentString,
  elementPictureFragmentString,
  imageFragmentString,
  elementTextFragmentString,
  paragraphFragmentString,
].join('\n\n')

export type GetOrCreateEditableCardForRecipientData = {
  getOrCreateEditableCardForRecipient: {
    card: {
      __typename: 'Card'
      id: string
      type: CardType
      isHorizontal: boolean
      frontPreviewUrl: string
      insidePreviewUrl: Maybe<string>
      flapPreviewUrl: Maybe<string>
      backPreviewUrl: string
      isNewEditorCard: boolean
      panels: PanelFragment[]
    }
  }
}

export type GetOrCreateEditableCardForRecipientVariables = {
  recipientId: string
  productionId?: Maybe<string>
}

export type GetOrCreateEditableCardForRecipient = Operation<
  GetOrCreateEditableCardForRecipientData,
  GetOrCreateEditableCardForRecipientVariables
>

export const GetOrCreateEditableCardForRecipient = ({
  recipientId,
  productionId,
}: GetOrCreateEditableCardForRecipientVariables): GetOrCreateEditableCardForRecipient => ({
  query: getOrCreateEditableCardForRecipientString,
  variables: {
    recipientId,
    productionId,
  },
})
